import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import AuthGuard from './auth/AuthGuard';
import { authRoles } from './auth/authRoles';
import Loadable from './components/Loadable';
import MatxLayout from './components/MatxLayout/MatxLayout';
import materialRoutes from 'app/views/material-kit/MaterialRoutes';
import userRoutes from './views/entities/users/UserRoutes';
import sellerRoutes from './views/entities/sellers/SellerRoutes';
import customerRoutes from './views/entities/customers/CustomerRoutes';
import storeRoutes from './views/entities/stores/StoreRoutes';
import insuranceRoutes from './views/entities/insurances/InsuranceRoutes';
import transactionRoutes from './views/entities/transactions/TransactionRoutes';
import warrantyRoutes from './views/entities/warranties/WarrantyRoutes';
import warrantyCardRoutes from './views/entities/warrantyCards/WarrantyCardRoutes';
import NewPassword from './views/sessions/NewPassword';
import phoneRoutes from './views/entities/phones/PhoneRoutes';
import agencyRequestRoutes from './views/entities/agency_requests/AgencyRequestsRoutes';
import contactRequestRoutes from './views/entities/contact_requests/ContactRequestsRoutes';
import cardRequestRoutes from './views/entities/card_requests/CardRequestsRoutes';
import agentRoutes from './views/entities/agents/AgentRoutes';
import serviceCenterRoutes from './views/entities/serviceCenters/ServiceCenterRoutes';
import bannerRoutes from './views/entities/banners/BannerRoutes';

// session pages
const NotFound = Loadable(lazy(() => import('app/views/sessions/NotFound')));
const JwtLogin = Loadable(lazy(() => import('app/views/sessions/JwtLogin')));
const JwtRegister = Loadable(lazy(() => import('app/views/sessions/JwtRegister')));
const ForgotPassword = Loadable(lazy(() => import('app/views/sessions/ForgotPassword')));

// echart page
const AppEchart = Loadable(lazy(() => import('app/views/charts/echarts/AppEchart')));

// dashboard page
const Analytics = Loadable(lazy(() => import('app/views/dashboard/Analytics')));

const routes = [
  {
    element: (
      <AuthGuard>
        <MatxLayout />
      </AuthGuard>
    ),
    children: [
      ...materialRoutes,
      ...userRoutes,
      ...sellerRoutes,
      ...customerRoutes,
      ...storeRoutes,
      ...insuranceRoutes,
      ...transactionRoutes,
      ...warrantyRoutes,
      ...warrantyCardRoutes,
      ...phoneRoutes,
      ...agencyRequestRoutes,
      ...contactRequestRoutes,
      ...cardRequestRoutes,
      ...agentRoutes,
      ...serviceCenterRoutes,
      ...bannerRoutes,

      // dashboard route
      {
        path: '/dashboard/default',
        element: <Analytics />,
        auth: authRoles.admin,
      },

      // e-chart rooute
      {
        path: '/charts/echarts',
        element: <AppEchart />,
        auth: authRoles.editor,
      },
    ],
  },

  // session pages route
  { path: '/session/404', element: <NotFound /> },
  { path: '/session/signin', element: <JwtLogin /> },
  { path: '/session/signup', element: <JwtRegister /> },
  { path: '/session/forgot-password', element: <ForgotPassword /> },
  { path: '/session/new-password', element: <NewPassword /> },

  { path: '/', element: <Navigate to="dashboard/default" /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
